import { connect } from 'react-redux';
import { changeClassesEditOrder, changeEditOrder, changeInforEditOrder, changeItemEditOrder } from './../../../../../actions/editOrder';
import OrderInformationComponent from './../../../components/order-information';
import './styles.css';

class OrderInformation extends OrderInformationComponent {
    componentDidMount() {
        this.loadChannel()
        this.props.onChange({value: true, column: 'check_type_order'})
    }
}

const mapStateToProps = state => {
    return {
        classes: state.editOrder.classes,
        information: state.editOrder.information,
        order: state.editOrder
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeInformation: payload => {
            dispatch(changeInforEditOrder(payload))
        },
        onChangeClasses: payload => {
            dispatch(changeClassesEditOrder(payload))
        },
        onChange: payload => {
            dispatch(changeEditOrder(payload))
        },
        onChangeItem: payload => {
            dispatch(changeItemEditOrder(payload))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderInformation)


// WEBPACK FOOTER //
// ./src/containers/orders/edit/components/order-information/index.js